import { Fundraising } from '~/pages/homepage/pages/features/fundraising'

export default Fundraising
